import { useContext } from 'react';
import { OrgProjectContextType } from '@/context/OrgProjectContext/types.ts';
import OrgProjectContext from '@/context/OrgProjectContext/OrgProjectContext.tsx';

export const useOrgProject = (): OrgProjectContextType => {
  const ctx = useContext(OrgProjectContext);
  if (!ctx) throw new Error('useOrgProject must be used within OrgProjectProvider');
  return ctx;
};
